// extracted by mini-css-extract-plugin
export var divider = "_lo-0";
export var systemMessage = "_lo-1";
export var systemMessageWrapper = "_lo-2";